import script from "./AccordionItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./AccordionItem.vue?vue&type=script&setup=true&lang=ts"

import "./AccordionItem.vue?vue&type=style&index=0&id=a38d12fc&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a38d12fc"]])

export default __exports__